import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { WidgetBoxedLayoutComponent } from './custom-layout/widget-boxed-layout/widget-boxed-layout.component';
import { BelenderRoutes } from 'src/app/belender/interfaces/belender-route.interface';
import { QuicklinkModule, QuicklinkStrategy } from 'ngx-quicklink';


const routes: BelenderRoutes = [
  
  {
    path: 'privacity-cetelem',
    loadChildren: () => import('./pages/privacity-cetelem/privacity-cetelem.module').then(m => m.PrivacityCetelemModule),
  },
  {
    path: 'widget',
    loadChildren: () => import('./pages/widget/widget.module').then(m => m.WidgetModule),
  },
  {
    path: 'widget-boxed',
    component: WidgetBoxedLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./custom-layout/widget-boxed-layout/widget-boxed-layout.module').then(m => m.WidgetBoxedLayoutModule),
      }
    ]
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    preloadingStrategy: QuicklinkStrategy,
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled'
})
    
  ],
  exports: [RouterModule, QuicklinkModule]
})
export class AppRoutingModule {
}
